import SideBar from "./sidebar";
import FullScreenLayout from "./full-screen-layout";
import MainMenuItems from "./main-menu-items";
import NavMenuItems from "./nav-menu-items";
import MainBodyLayout from "./main-body-layout";
import { BusinessProvider } from "/contexts/business-context";
import { UserProvider } from "/contexts/user-context";
import { SideBarProvider } from "../../contexts/side-bar-context";
import Loader from "../ui/loader";
import BottomNav from "./bottom-nav";
import { TableProvider } from "../../contexts/table-context";
import Notification from "../ui/notification";
import { ThemeProvider } from "next-themes"
import { FileProvider } from "../../contexts/files-context";
import { TableFilterProvider } from "../../contexts/table-filter-context";
import Announcement from "../ui/announcement";
import { InstalledPegsProvider } from "../../contexts/installed-pegs-context";

export default function Shell({ children }) {
  return (
    <>
      <UserProvider>
        <BusinessProvider>
          <InstalledPegsProvider>
            <Loader>
              <SideBarProvider>
                <TableFilterProvider>
                  <TableProvider>
                    <FileProvider>
                      <ThemeProvider>
                        <FullScreenLayout>
                          <Announcement />
                          <SideBar>
                            <MainMenuItems>
                              <NavMenuItems />
                            </MainMenuItems>
                            <BottomNav />
                          </SideBar>
                          <MainBodyLayout>
                            {children}
                          </MainBodyLayout>
                        </FullScreenLayout>
                      </ThemeProvider>
                    </FileProvider>
                  </TableProvider>
                </TableFilterProvider>
              </SideBarProvider>
            </Loader>
          </InstalledPegsProvider>
        </BusinessProvider>
      </UserProvider>
      <Notification />
    </>
  );
}
